import { render, staticRenderFns } from "./TrainingInfo.vue?vue&type=template&id=66ab239d&scoped=true&"
import script from "./TrainingInfo.vue?vue&type=script&lang=js&"
export * from "./TrainingInfo.vue?vue&type=script&lang=js&"
import style0 from "./TrainingInfo.vue?vue&type=style&index=0&id=66ab239d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ab239d",
  null
  
)

export default component.exports